import { render, staticRenderFns } from "./UiCount.vue?vue&type=template&id=6f8e66f0&lang=pug&"
import script from "./UiCount.vue?vue&type=script&lang=js&"
export * from "./UiCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports